"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { FormEditTableConstants } from "Constants/Forms/FormEditTableConstants";
import { ApplicationConstants } from "Constants/ApplicationConstants";
import { Map } from "immutable";
var defStore = {
  dataFormButtons: null,
  dataContextMenu: null,
  formID: null,
  type: null,
  tableTitle: '',
  tableInstance: null,
  showTable: false
};
var CHANGE_EVENT = 'change';
var _store = {};

var FormEditTableStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(FormEditTableStoreClass, _StoreClass);

  function FormEditTableStoreClass() {
    _classCallCheck(this, FormEditTableStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormEditTableStoreClass).apply(this, arguments));
  }

  _createClass(FormEditTableStoreClass, [{
    key: "setStoreGuid",
    value: function setStoreGuid(uuid) {
      _store[uuid] = Map(defStore).toObject();
    }
  }, {
    key: "updateStoreGuid",
    value: function updateStoreGuid(uuid, nextUUID) {
      if (_store[uuid]) {
        _store[nextUUID] = _store[uuid];
        delete _store[uuid];
      }
    }
  }, {
    key: "setStoreFormID",
    value: function setStoreFormID(formID, uuid) {
      _store[uuid].formID = formID;
    }
  }, {
    key: "getInitList",
    value: function getInitList() {
      return Map(defStore).toObject();
    }
  }, {
    key: "getList",
    value: function getList(uuid) {
      return _store[uuid];
    }
  }, {
    key: "destructor",
    value: function destructor(uuid) {
      if (uuid != null) delete _store[uuid];else _store = Map(defStore).toObject();
    }
  }]);

  return FormEditTableStoreClass;
}(StoreClass);

var FormEditTableStore = new FormEditTableStoreClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case FormEditTableConstants.LOAD_TABLE_CONTEXT_MENU_DATA:
      if (_store[action.formUUID]) _store[action.formUUID].dataContextMenu = _objectSpread({}, action.dataContextMenu);
      FormEditTableStore.emit(CHANGE_EVENT);
      break;

    case FormEditTableConstants.FORM_EDIT_TABLE_FORM_SHOW_TABLE:
      if (_store[action.formUUID]) _store[action.formUUID].showTable = action.show;
      FormEditTableStore.emit(CHANGE_EVENT);
      break;

    case ApplicationConstants.DO_LOGOUT:
      {
        FormEditTableStore.destructor();
        break;
      }

    default:
      return true;
  }
});
export default FormEditTableStore;